<div class="claroTag_container" [style.width]="width" [style.height]="height" [style.background-color]="backgroundColor">
    <mat-icon [style.color]="fontColor" [style.font-size]="iconSize">{{iconName}}</mat-icon>
    <span [style.color]="fontColor" [style.font-size]="fontSize">{{text}}</span>
</div>
